import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { COURSE, COURSE_BRAND, COURSE_PLANS } from "@/config/course";

const lowestPrice = Math.min(...COURSE_PLANS.map((p) => p.price));

/**
 * Front-page entry point into the course experience. Links to the course
 * homepage, which leads into the catalog.
 */
export const CourseSpotlight = () => (
  <section className="py-16 sm:py-20 px-4" aria-labelledby="course-spotlight-heading">
    <div className="mx-auto max-w-5xl rounded-2xl border border-primary/40 bg-card/60 p-8 sm:p-12 text-center space-y-5">
      <Badge variant="secondary" className="mx-auto">Courses by {COURSE_BRAND.instructor}</Badge>
      <h2 id="course-spotlight-heading" className="text-2xl sm:text-4xl font-bold text-foreground">
        Build your own AI assistant in about 30 minutes
      </h2>
      <p className="mx-auto max-w-2xl text-muted-foreground">
        {COURSE.subheadline}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Button asChild size="lg">
          <Link to="/courses/start">
            <GraduationCap className="mr-2 h-4 w-4" aria-hidden />
            Start learning
            <ArrowRight className="ml-2 h-4 w-4" aria-hidden />
          </Link>
        </Button>
        <Button asChild variant="outline" size="lg">
          <Link to={`${COURSE.slug}/about`}>Watch the preview</Link>
        </Button>
        <Link to="/ai-video-lab" className="focus-ring text-sm font-medium text-primary underline">
          New: free AI Video Lab with AI Kenny
        </Link>
        <span className="text-sm text-muted-foreground">Launch offers from ${lowestPrice}</span>
      </div>
    </div>
  </section>
);

export default CourseSpotlight;
